import React, { useEffect, useState } from "react";
import useAxios from "../../helpers/Hooks/useAxios";
import { URLS } from "../../helpers/URLS";
import { Box, TextField, InputAdornment, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SearchIcon from '@mui/icons-material/Search';
import ViewAssetsModal from "./ViewAssetsModal";
import './AssetManagement.scss';
import '../../assets/scss/tables.scss';

const columnData = [
    {
        id: "s.no",
        title: 'S.No',
        minWidth: '80px',
        isSticky: false,
        alignItem: 'center'
    },
    {
        id: "employeeCode",
        title: 'Employee Code',
        minWidth: '150px',
        isSticky: false,
        alignItem: 'center'

    },
    {
        id: "employeeName",
        title: 'Employee Name',
        minWidth: '200px',
        isSticky: false,
        alignItem: 'left'


    },
    {
        id: "emailID",
        title: 'Employee Email',
        minWidth: '200px',
        isSticky: false,
        alignItem: 'left'

    },
    {
        id: "mobile",
        title: 'Mobile Number',
        minWidth: '200px',
        isSticky: false,
        alignItem: 'left'


    },
    {
        id: "designation",
        title: 'Designation',
        minWidth: '200px',
        isSticky: false,
        alignItem: 'left'

    },
    {
        id: "managerName",
        title: 'Manager Name',
        minWidth: '200px',
        isSticky: false,
        alignItem: 'left'

    },

    // {
    //     id: "actions",
    //     title: 'Actions',
    //     minWidth: '200px',
    //     isSticky:true
    // }
]

/* Assets still with the employee — returned ones stay on the record but are
   not what the count is about. */
const heldAssets = (row) => (row?.Assets || []).filter((asset) => !asset?.isReturned);

const AssetsTip = ({ assets }) => (
    <div className="wh-tip-list">
        <b>{assets.length} asset{assets.length === 1 ? '' : 's'} issued</b>
        <ul>
            {assets.map((asset, i) => (
                <li key={asset?._id || i}>
                    <span>{asset?.item}</span>
                    <em>{asset?.serial_no || 'no serial'}</em>
                </li>
            ))}
        </ul>
    </div>
);

const AssetManagement = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [employees, setEmployees] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [search, setSearch] = useState("");

    const [isStatusModel, setIsStatusModel] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState(null)


    const { fetchData } = useAxios();

    const tableRef = React.createRef();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        tableRef.current.scrollTop = 0;
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    useEffect(() => {
        getEmployeeList();
    }, []);
    const getEmployeeList = async () => {
        const response = await fetchData({
            url: URLS.getEmpoyees,
            method: "get",
        });
        setEmployees(response?.data || []);
        setFilteredEmployees(response?.data || [])
    };

    // console.log(employees, "employees employees")
    const reloadEmployeesList = (event) => {
        event.preventDefault(); // Fixed typo here
        // const searchItem = search?.trim()?.toLowerCase();
        const searchItem = event.target.value?.trim()?.toLowerCase();
        const filteredData = employees?.filter(
            (employee) =>
                employee?.employeeCode?.toLowerCase()?.includes(searchItem) ||
                employee?.employeeName?.toLowerCase()?.includes(searchItem) ||
                employee?.emailID?.toLowerCase()?.includes(searchItem)
        );
        setFilteredEmployees(filteredData);
    };

    const modelHandle = () => {
        setIsStatusModel(!isStatusModel)
    }
    return (
        <div className="row mb-1 pb-1 wh-table">
            <div className="col-sm-12 mb-2">
                <div className="wh-toolbar">
                    <h4 className="title">Employee's List</h4>
                    <Box className="wh-toolbar-search">
                        <form onSubmit={reloadEmployeesList}>
                            <TextField
                                type="text"
                                id="outlined-basic"
                                label="Search"
                                variant="outlined"
                                value={search}
                                onChange={(e) => { setSearch(e.target.value); reloadEmployeesList(e) }}
                                onBlur={(e) => { if (e.target.value === '') { reloadEmployeesList(e) } }}
                                name="search"
                                size="small"
                                fullWidth
                                className="bg-white"
                                autoComplete='off'
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton type="submit" className="p-1">
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </form>
                    </Box>
                </div>

            </div>
            <div className="col-sm-12 mb-1">
                <div className="card d-flex flex-column  pb-1" >
                    <TableContainer sx={{ maxHeight: 480, maxWidth: '100%' }} className='table-container-cls' ref={tableRef}>
                        <Table stickyHeader aria-label="sticky table" className='table-cls' >
                            <TableHead>
                                <TableRow className='py-1'>
                                    {columnData.map((column) => (
                                        <TableCell
                                            key={"column" + column?.id}
                                            align={column?.alignItem}
                                            // align="center"
                                            style={{ minWidth: column?.minWidth }}
                                        >
                                            {column?.title}
                                        </TableCell>
                                    ))}
                                    <TableCell key={'assets-count-key'} align="center"
                                        className="sticky_right_header_column wh-sticky-2">Assets</TableCell>
                                    <TableCell key={'actions-key'} className="sticky_right_header_column">View</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredEmployees?.length > 0 && filteredEmployees
                                    ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    ?.map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id} className='py-2'>
                                            {columnData.map((column, i) => (
                                                <TableCell key={`${row[column?.id]}-${index}-${i}`} align={row[column?.id] ? column?.alignItem : 'center'}> {`${column?.id === 's.no' ? index + 1 : row[column?.id] || '---'} `} </TableCell>
                                            ))}
                                            <TableCell key={'assets-count-row+' + index} align="center"
                                                className="sticky_right_column wh-sticky-2">
                                                {heldAssets(row).length > 0
                                                    ? <Tooltip arrow placement="left"
                                                        classes={{ tooltip: 'wh-tip' }}
                                                        title={<AssetsTip assets={heldAssets(row)} />}>
                                                        <span className="wh-count-pill">
                                                            <Inventory2OutlinedIcon />
                                                            {heldAssets(row).length}
                                                        </span>
                                                    </Tooltip>
                                                    : <span className="wh-count-pill is-empty">
                                                        <Inventory2OutlinedIcon />0
                                                    </span>}
                                            </TableCell>
                                            <TableCell key={'actions-row-key+' + index} className="sticky_right_column">
                                                <Tooltip title='View assets' placement="top" arrow>
                                                    <IconButton className="actions-btn-cls" onClick={() => { setSelectedEmployee(row); modelHandle() }}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 15, 20, 25, 50, 100]}
                        component="div"
                        count={filteredEmployees.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className='table-pagination-container'
                    />
                </div>
            </div>
            {isStatusModel && <ViewAssetsModal getEmployeeList={getEmployeeList} isStatusModel={isStatusModel} modelHandle={modelHandle} selectedEmployee={selectedEmployee} />}
        </div>
    )
}

export default AssetManagement